<template>
    <div class="container">
        <h1 v-if="term" class="text-center">Définition : {{ firstLetterCapital(term.name) }}</h1>
        <h1 v-else class="text-center">Le glossaire Crypto</h1>

        <div class="row mt-5">
            <div class="col col-lg-3 definitions">
                <h3>Définitions</h3>
                <b-form-input v-model="searchText" placeholder="Rechercher" style="margin-bottom: 10px;"></b-form-input>
                <div class="definition-list">
                    <a v-for="term of searchTerms()" :href="'/definition/' + normalize(term.name)" :key="term.name">
                        {{ firstLetterCapital(term.name) }}
                        <span class="badge badge-secondary" v-if="term.category">{{ term.category }}</span>
                    </a>
                </div>
            </div>
            <div class="col col-lg-9">
                <div v-if="term">
                    <h2 style="margin-top: 0;">{{ firstLetterCapital(term.name) }}</h2>
                    <div v-if="term.alternatives" class="alternatives mb-3">
                        Aussi : <b>{{ term.alternatives.join(", ") }}</b>
                    </div>
                    <p>{{ term.def }}</p>

                    <p v-if="term.category">
                        Catégorie: <span class="badge badge-secondary">{{ term.category }}</span>
                    </p>

                    <p v-if="term.link" class="mt-4">
                        <b>Article</b> :
                        <b
                            ><a :href="term.link.href">{{ term.link.name }}</a></b
                        >
                    </p>
                </div>
                <div v-else>
                    <h2 style="margin-top: 0;">Les définitions de la cryptomonnaie</h2>
                    <p>
                        Il n'est pas rare de tomber sur un terme qu'on ne comprend pas. Le monde de la cryptomonnaie a ses propres codes, termes et définitions, et n'en déplaise aux académiciens et ferveurs défenseurs de notre belle langue, l'anglais
                        y est omniprésent. Ce glossaire est là pour vous aider à tout décoder, et à vous guider dans vos recherches.
                    </p>

                    <p>
                        Utilisez la colonne de gauche pour trouver les définitions des termes que vous recherchez.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DefaultLayout from "../../components/DefaultLayout.vue";
import createHeader from "../../js/meta.js";
import { BFormInput } from "bootstrap-vue";
import slugify from "slugify";
import _ from "lodash";

// import all glossaries
import glossary from "../../static/glossary/glossary.json";

export default {
    components: {
        DefaultLayout,
        BFormInput,
    },
    data() {
        return {
            terms: [],
            term: null,
            searchText: "",
        };
    },
    async asyncData({ $content, params, error }) {
        let terms = Array.from(glossary.terms);

        // load additional glossaries
        var glossaries = [];
        for (let category in glossary.extend) {
            let g = await import(`../../static/glossary/glossary-${category}.json`);
            _.each(g.terms, (t) => {
                t.category = category;
            });
            terms = terms.concat(Array.from(g.terms));
        }

        // check if the term exists in glossary
        let term = _.find(terms, (t) => {
            let name = slugify(t.name.toLowerCase());
            let alternatives = t.alternatives && t.alternatives.length > 0 ? t.alternatives.map((a) => slugify(a.toLowerCase())) : [];

            return name == params.slug || alternatives.indexOf(params.slug) !== -1;
        });

        terms = terms.sort((a, b) => {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });

        if (term) {
            return {
                terms: terms,
                term: term,
            };
        } else {
            if (params.slug === undefined) {
                // definition root page
                return {
                    terms: terms,
                    term: null,
                };
            } else {
                error({
                    statusCode: 404,
                    message: "Cette définition n'existe pas",
                });
            }
        }
    },
    head() {
        if (this.term) {
            return createHeader({
                title: `Définition de ${this.term.name} - Stakepool.fr`,
                description: this.term.def,
            });
        } else {
            return createHeader({
                title: `Le Glossaire Crypto - Stakepool.fr`,
                description: "Les termes et définition du monde de la cryptomonnaies, dans ce glossaire.",
            });
        }
    },
    methods: {
        firstLetterCapital(s) {
            return s.charAt(0).toUpperCase() + s.slice(1);
        },

        searchTerms() {
            if (!this.searchText || this.searchText.length == 0) {
                return this.terms;
            } else {
                let terms = _.filter(this.terms, (t) => {
                    let alternatives = Array.from(t.alternatives || []);
                    alternatives.unshift(t.name);

                    for (let alternative of alternatives) {
                        if (alternative.indexOf(this.searchText) !== -1) {
                            return true;
                        }
                    }

                    return false;
                });
                return terms;
            }
        },

        normalize(s) {
            return slugify(s.toLowerCase());
        },
    },
};
</script>

<style>
.definition-list {
    max-height: 400px;
    overflow-y: auto;
}

.definition-list a {
    display: block;
}
</style>
